import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport } from "@material-ui/data-grid";

import classes from "../../CampaignsDashboard.module.scss";

const SiteReportsTableToolbar: FC = () => {
  return (
    <GridToolbarContainer className={classes.toolbar}>
      <Typography variant="h3">Site Reports</Typography>

      <div className={classes.toolbarControls}>
        <GridToolbarColumnsButton className={classes.selectMetricsBtn} startIcon={null} />
        <GridToolbarExport className={classes.exportButton} />
      </div>
    </GridToolbarContainer>
  );
};

export default SiteReportsTableToolbar;
